import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { ravelComponentPath } from '../../../../common/RavelComponentPath.js';


export class RavelRecorder extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #image {
            display: none;
            width: 100px;
            margin: 20px;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <img id="image" src="${ravelComponentPath}/images/recorder.png"/>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'name', 'show-image'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        // e.g. this.icon = this.shadowRoot.querySelector('#icon');
        this.mediaRecorder = null;					
        this.input = null;
        this.chunks = [];					
        this.audioContext = window.AudioContext || window.webkitAudioContext; 
        this.audioUrl = null;
        this.name = 'foo';
        this.showImage = false;
    }

    setup = () => {
        this.observedMessages = [`${this.name}`];
        this.subscribe(this.observedMessages); 
        if (this.showImage) {
            this.shadowRoot.querySelector('#image').style.display = 'block';
        }  
        this.addEventListener(`${this.name}`, this.handleEvent);
    }
    
    teardown = () => {
        this.unsubscribe(this.observedMessages);
    }

    handleEvent = (evt) => {
        if (evt.detail.cmd === 'start-recording') {
            this.record();
        }
        if (evt.detail.cmd === 'stop-recording') {
            this.stopRecording();
        }
        if (evt.detail.cmd === 'play-recording') {
            this.playRecording();
        }
    }
    
    loadSavedRecording = () => {
        this.readBlobFromDisk();
    }
	
	record = async () => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ audio: true })
            .then((stream) => {
                this.mediaRecorder = null;
                this.mediaRecorder = new MediaRecorder(stream);
                this.mediaRecorder.start();
                
                let chunks = [];
                this.mediaRecorder.ondataavailable = (e) => {
                    chunks.push(e.data);
                };
                this.mediaRecorder.onstop = async (e) => {
                    let arrayBuffer = await chunks[0].arrayBuffer();
                    let trimmedRecording = await this.trimSilence(arrayBuffer);
                    let normalizedRecording = await this.normalize(trimmedRecording);
                    const blob = new Blob([normalizedRecording], { type: "audio/wav;" });
                    chunks = [];
                    this.audioUrl = URL.createObjectURL(blob);
            		await this.saveBlob(blob);
                };
            })
            .catch((err) => {
              console.warn(`The following getUserMedia error occurred: ${err}`);
            });
        } else {
            console.warn(`Couldn't resolve media devices`);
        }
	}

    trimSilence = async (buffer) => {
        return new Promise((resolve, reject) => { 
            let arrayBuffer = new Uint8Array(buffer);
            // find the first non-zero sample in the recorded samples
            let start = 0;
            for (let i = 0; i < arrayBuffer.length; i++) {
                if (arrayBuffer[i] !== 0) {
                    start = i;
                    break;
                }
            }
            // find the last non-zero sample in the recorded samples
            let end = arrayBuffer.length - 1;
            for (let i = arrayBuffer.length - 1; i >= 0; i--) {
                if (arrayBuffer[i] !== 0) {
                    end = i;
                    break;
                }
            }
            // trim the silence from the beginning and end of the recorded samples
            resolve(arrayBuffer.slice(start, end + 1).buffer);
        });
    }

    normalize = async (arrayBuffer) => {
        return new Promise((resolve, reject) => { 
            resolve(arrayBuffer);
        });
    }

        /* something like this:
        return new Promise((resolve, reject) => { 
            try {
                // Convert ArrayBuffer to Float32Array
                let samples = new Float32Array(arrayBuffer);

                // Find the maximum absolute value in the samples
                let max = 0;
                for (let i = 0; i < samples.length; i++) {
                    max = Math.max(max, Math.abs(samples[i]));
                }
                // If max is 0, avoid divide-by-zero
                if (max === 0) {
                    resolve(samples); // nothing to normalize
                    return;
                }
                // Normalize the recorded samples
                let normalizedSamples = samples.map(sample => sample / max);
                resolve(normalizedSamples.buffer); // return as ArrayBuffer
            } catch (err) {
                reject(err);
            }
        });
        */

	stopRecording =  async (n) => {
        if (this.mediaRecorder) {
		    this.mediaRecorder.stop();
        }
	}

    playRecording = () => {
        console.log('play recording');
    }
	
	saveBlob = async (blob) => {
	   let reader = new window.FileReader();
	   let stringArray = '';
       
       return new Promise((resolve, reject) => { 
		   reader.readAsDataURL(blob);     // Base64 encoded
		   reader.onloadend = () => {
			   stringArray = reader.result;
			   stringArray = stringArray.split(',')[1];
			   // save to local storage
		   } 
       });
	}
	
	bytestringToBlob = (b64Data) => {
		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += 512) {
		const slice = byteCharacters.slice(offset, offset + 512);

		const byteNumbers = new Array(slice.length);
		for (let i = 0; i < slice.length; i++) {
		  byteNumbers[i] = slice.charCodeAt(i);
		}

		const byteArray = new Uint8Array(byteNumbers);
		    byteArrays.push(byteArray);
		}

		const blob = new Blob(byteArrays, { type: 'audio/wav' });
		return blob;
	}
	
	readBlobFromLocalStorage = () => {
		// this.audioSlotUrl = URL.createObjectURL(FluxlyRecordings.bytestringToBlob(blobData));
	}

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        
        if (name === 'name') {
            this.name = newValue;
        }
        if (name === 'show-image') {
            this.showImage = true;
        }
    }
}
